import React from 'react'

import TermsEN from './en'
import TermsFR from './fr'

function Terms({ locale }) {
  if (locale === 'fr-FR') return <TermsFR />
  return <TermsEN />
}

export default Terms
